export default __webpack_public_path__ + "static/char-s-05-jp-62f5a236a18b1146e30c157a4f72c476.png";